/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { DependencyGraphDto } from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary Graph
 */
export const getIntelligenceDependenciesProjectProjectIdGraph = (
  projectId: number,
  signal?: AbortSignal,
) => {
  return customInstance<DependencyGraphDto>({
    url: `/intelligence/dependencies/project/${projectId}/graph`,
    method: "GET",
    signal,
  });
};

export const getGetIntelligenceDependenciesProjectProjectIdGraphInfiniteQueryKey =
  (projectId?: number) => {
    return [
      "infinite",
      `/intelligence/dependencies/project/${projectId}/graph`,
    ] as const;
  };

export const getGetIntelligenceDependenciesProjectProjectIdGraphQueryKey = (
  projectId?: number,
) => {
  return [`/intelligence/dependencies/project/${projectId}/graph`] as const;
};

export const getGetIntelligenceDependenciesProjectProjectIdGraphInfiniteQueryOptions =
  <
    TData = InfiniteData<
      Awaited<
        ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
      >
    >,
    TError = void,
  >(
    projectId: number,
    options?: {
      query?: Partial<
        UseInfiniteQueryOptions<
          Awaited<
            ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetIntelligenceDependenciesProjectProjectIdGraphInfiniteQueryKey(
        projectId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
      >
    > = ({ signal }) =>
      getIntelligenceDependenciesProjectProjectIdGraph(projectId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!projectId,
      staleTime: 10000,
      refetchOnWindowFocus: false,
      ...queryOptions,
    } as UseInfiniteQueryOptions<
      Awaited<
        ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetIntelligenceDependenciesProjectProjectIdGraphInfiniteQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>>
  >;
export type GetIntelligenceDependenciesProjectProjectIdGraphInfiniteQueryError =
  void;

export function useGetIntelligenceDependenciesProjectProjectIdGraphInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>>
  >,
  TError = void,
>(
  projectId: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<
          ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
          >,
          TError,
          Awaited<
            ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceDependenciesProjectProjectIdGraphInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<
          ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
          >,
          TError,
          Awaited<
            ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceDependenciesProjectProjectIdGraphInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<
          ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Graph
 */

export function useGetIntelligenceDependenciesProjectProjectIdGraphInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<
          ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetIntelligenceDependenciesProjectProjectIdGraphInfiniteQueryOptions(
      projectId,
      options,
    );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetIntelligenceDependenciesProjectProjectIdGraphQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetIntelligenceDependenciesProjectProjectIdGraphQueryKey(projectId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>>
  > = ({ signal }) =>
    getIntelligenceDependenciesProjectProjectIdGraph(projectId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!projectId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIntelligenceDependenciesProjectProjectIdGraphQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>>
  >;
export type GetIntelligenceDependenciesProjectProjectIdGraphQueryError = void;

export function useGetIntelligenceDependenciesProjectProjectIdGraph<
  TData = Awaited<
    ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
  >,
  TError = void,
>(
  projectId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
          >,
          TError,
          Awaited<
            ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceDependenciesProjectProjectIdGraph<
  TData = Awaited<
    ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
          >,
          TError,
          Awaited<
            ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceDependenciesProjectProjectIdGraph<
  TData = Awaited<
    ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Graph
 */

export function useGetIntelligenceDependenciesProjectProjectIdGraph<
  TData = Awaited<
    ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getIntelligenceDependenciesProjectProjectIdGraph>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetIntelligenceDependenciesProjectProjectIdGraphQueryOptions(
      projectId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
